import React from 'react';
import Loader from 'components/loader/Loader';

export const LoadingRenderer = (isLoading: boolean) => {
  return (
    <>
      {isLoading && (
        <div className='loading-renderer'>
          <Loader size='large' center />
        </div>
      )}
    </>
  );
};
